function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M186.4,248.2l-0.8-0.1l-0.5-0.1l-0.5-0.2l-0.5-0.2l-0.5-0.3l-0.3-0.2l-52.6-28.8c-1.2-0.7-2.2-1.7-2.7-3 c-0.5,1.3-1.5,2.4-2.7,3l-52.9,29l-0.4,0.2l-0.3,0.2l-0.2,0.1l-0.7,0.2l-0.9,0.2l-0.6,0l-0.5,0l-0.9-0.1l-0.6-0.2l-0.8-0.4 l-53.3-29.2c-1.3-0.7-2.3-1.9-2.8-3.3h-0.2l-0.1-1.2l0-0.8v-70.8c0-2.5,1.6-4.8,3.9-5.7L70,109.8V40.7c0-2.5,1.6-4.8,3.9-5.7 l57.4-27.3v0.8c0.9,0,1.7,0.3,2.4,0.6l51.1,25.9c2.2,0.9,3.7,3.1,3.7,5.6v68.7l0.1,0.6c0.9,0,1.8,0.2,2.6,0.6l51.1,25.9 c2.2,0.9,3.7,3.1,3.7,5.6V215h-0.3c-0.5,1.4-1.5,2.6-2.8,3.3l-52.9,29l-0.4,0.2l-0.4,0.2l-0.2,0.1l-0.7,0.2l-1,0.2l-0.4,0 L186.4,248.2L186.4,248.2z M193.3,232.4l41-22.5V153l-41,22.5V232.4z M75.8,232.4l41-22.5V153l-41,22.5V232.4z M180.7,231.9V175 l-17.1-9.4v28l-14.2-6.7v-29.1l-9.7-5.3v56.9L180.7,231.9z M63.2,231.9V175L46,165.6v19L31.9,178l0-20.1l-9.7-5.3v56.9L63.2,231.9z  M186.8,164.4l40.1-22l-15.7-8l-40.5,21.1L186.8,164.4z M69.2,164.4l40.1-22l-15.7-8l-40.5,21.1L69.2,164.4z M38.1,147.4L78,126.5 l-7.2-3.6l-41.4,19.7L38.1,147.4z M155.7,147.4l39.9-20.8l-7.2-3.6L147,142.6L155.7,147.4z M123.2,131.8V74.9l-17.1-9.4v12.6 l-14.2-6.7V57.7l-9.7-5.3v56.9L123.2,131.8L123.2,131.8z M136,130.7l41-22.5V51.3l-41,22.5V130.7L136,130.7z M129.2,62.9l40.2-22.5 l-15.7-8l-40.6,21.7L129.2,62.9z M101,47.3l40-21.3l-9.7-4.8L89.8,41.3L101,47.3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M149.4,186.9c0,0,5.9,19.4,14.2,6.6L149.4,186.9z M31.9,178c0,0,5.9,19.4,14.2,6.6L31.9,178z M91.9,71.3 c0,0,5.9,19.6,14.2,6.8L91.9,71.3z"
});

const SvgIconInventory = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-bar-chart-fill",
    viewBox: "0 0 250 250",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconInventory, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Inventory.35ae8850.svg";
export { ForwardRef as ReactComponent };